const Portfolio = () => {
  return (
    <section id="portfolio" className="section">
      <h2>Portfolio</h2>
      <div className="portfolio-grid">
        <div className="portfolio-item">
          <h3>Fitness Tracker App</h3>
          <p>
            React + Node.js application to track workouts, visualize data with
            Chart.js, and manage authentication using JWT.
          </p>
          <a
            href="https://github.com/fmzaki/fitness-app"
            target="_blank"
            rel="noopener noreferrer"
          >
            View Project
          </a>
        </div>
        <div className="portfolio-item">
          <h3>Tuition Center Management</h3>
          <p>
            User interface design and optimization for a tuition management
            system, focusing on usability and performance.
          </p>
          <a
            href="#contact"
            rel="noopener noreferrer"
          >
            Case study coming soon
          </a>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
